import React from 'react';
export const footerDropContext = React.createContext(() => { });
export const FooterDropContextProvider = footerDropContext.Provider;
export const headerDropContext = React.createContext(() => { });
export const HeaderDropContextProvider = headerDropContext.Provider;
export const rowHandleRefContext = React.createContext(() => { });
export const RowHandleRefContextProvider = rowHandleRefContext.Provider;
